
    var riot = require('riot')
    riot.tag2('gb-rich-content-zone', '<gb-raw content="{$zone.richContent}"></gb-raw>', '', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/template/gb-rich-content-zone.tag.html